<div class="po-type-form">
    <h6 class="form-section-title">Material</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="expMaterial">Material</label>
            <input type="text" class="form-control" [(ngModel)]="item().material" name="expMaterial" id="expMaterial" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="expVendorMat">Vendor Mat</label>
            <input type="text" class="form-control" [(ngModel)]="item().vendorMaterial" name="expVendorMat" id="expVendorMat" />
        </div>
        <div class="col-sm-2 col-6 form-group d-flex align-items-end">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="item().receiving" name="expReceiving" id="expReceiving" />
                <label class="form-check-label" for="expReceiving">Receiving</label>
            </div>
        </div>
    </div>

    <app-po-common-fields [item]="item()" [glAccountReadonly]="false"></app-po-common-fields>
</div>
